<template>
  <div class="info-box">
    <v-title title="Endorsement Type"></v-title>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
    >
      <el-row
        class="row-bg"
        :gutter="20"
        justify="space-around">

        <v-row-col
          :same="true"
          :same-number="12">
          <div class="form-item ">
            <span>Endorsement Effective Date</span>
            <el-form-item prop="endorsement_effective_date">
              <v-date-picker
                v-model="formData.endorsement_effective_date"
                :disabled="is_effective"
                @change="handlerComputed"
              ></v-date-picker>
            </el-form-item>
          </div>
        </v-row-col>
        <v-row-col
          :same="true"
          :same-number="24">
          <div
            class="form-item">
            <el-form-item>
              <v-checkbox-group
                v-model="formData.endorsement_type"
                :list="
                  endorsementType"
              ></v-checkbox-group>
            </el-form-item>
          </div>
        </v-row-col>
        <v-row-col
          :same="true"
          :same-number="24">
          <div class="form-item">
            <span>Notes</span>
            <el-form-item prop="notes">
              <v-input
                v-model="formData.notes"
                type="textarea"
                :rows="4"></v-input>
            </el-form-item>
          </div>
        </v-row-col>

      </el-row>

      <el-row
        class="row-bg flex-inline"
        :gutter="20"
        justify="space-around">
        <v-row-col>
          <v-title title="Endorsement Premium"></v-title>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span class="disable-span">Section 1 - Material Damage Premium </span>
              <el-form-item >
                <v-input
                  v-model.number="showData.premium_material_damage"
                  prepend="HKD"
                  disabled/>
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span class="disable-span">IA Levy</span>
              <el-form-item >
                <div class="flex-aligin flex">
                  <v-input
                    v-model.number="showData.section_1_ia_levy_vl"
                    prepend="HKD"
                    disabled
                    @change="handlerComputed"
                  />
                </div>
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span class="disable-span">Section 2 - Third Party Liability Premium</span>
              <el-form-item>
                <v-input
                  v-model.number="showData.premium_third_party"
                  prepend="HKD"
                  disabled/>
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span class="disable-span">IA Levy</span>
              <el-form-item >
                <div class="flex-aligin flex">
                  <v-input
                    v-model.number="showData.section_2_ia_levy_vl"
                    prepend="HKD"
                    disabled
                    @change="handlerComputed"/>

                </div>
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span class="disable-span">Original Gross Premium</span>
              <el-form-item >
                <v-input
                  v-model.number="showData.original_gross_premium"
                  prepend="HKD"
                  disabled/>
              </el-form-item>
            </div>
          </v-row-col>
        </v-row-col>
        <v-row-col
          :same="true"
          :same-number="24">
          <div class="hr-inline"></div>
        </v-row-col>
      </el-row>
      <el-row
        class="row-bg flex-inline"
        :gutter="20"
        justify="space-around">
        <v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span>Section 1 - Material Damage Premium</span>
              <el-form-item prop="base_premium">
                <v-input
                  v-model.number="formData.premium_material_damage"
                  prepend="HKD"
                  :disabled="risk.section_1==0"
                  @change="handlerRisk"/>
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span>IA Levy</span>
              <el-form-item prop="section_1_ia_levy_vl">
                <div class="flex flex-aligin">
                  <v-input
                    v-model.number="formData.section_1_ia_levy_vl"
                    prepend="HKD"
                    :disabled="formData.is_section_1_ia_levy_vl==0"
                    @change="handlerComputed"/>
                  <v-checkbox
                    v-model="formData.is_section_1_ia_levy_vl"
                    @change="handlerCheck"></v-checkbox>
                </div>
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span>Section 2 - Third Party Liability Premium</span>
              <el-form-item prop="loading">
                <v-input
                  v-model.number="formData.premium_third_party"
                  prepend="HKD"
                  :disabled="risk.section_2==0"
                  @change="handlerRisk"/>
              </el-form-item>
            </div>
          </v-row-col>

          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span>IA Levy</span>
              <el-form-item prop="section_2_ia_levy_vl">
                <div class="flex-aligin flex">
                  <v-input
                    v-model.number="formData.section_2_ia_levy_vl"
                    prepend="HKD"
                    :disabled="formData.is_section_2_ia_levy_vl==0"
                    @change="handlerComputed"/>
                  <v-checkbox
                    v-model="formData.is_section_2_ia_levy_vl"
                    @change="handlerCheck"></v-checkbox>
                </div>
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span>EC Levy %</span>
              <el-form-item prop="ia_levy">
                <v-input
                  v-model.number="formData.ia_levy"
                  append="%"
                  @change="handlerComputed"/>
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span class="disable-span">Total New Premium</span>
              <el-form-item>
                <v-input
                  v-model.number= "showData.total_premium"
                  prepend="HKD"
                  disabled/>
              </el-form-item>
            </div>
          </v-row-col>
        </v-row-col>
        <v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span class="disable-span">Endorsement Effective Date</span>
              <el-form-item>
                <v-date-picker
                  v-model="formData.endorsement_effective_date"
                  disabled></v-date-picker>
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span class="disable-span">Gross Premium Difference</span>
              <el-form-item>
                <v-input
                  v-model.number= "showData.gross_premium_difference"
                  prepend="HKD"
                  disabled/>
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span class="disable-span">Gross Premium Difference without IA Levy</span>
              <el-form-item>
                <v-input
                  v-model.number= "showData.basic_premium_difference"
                  prepend="HKD"
                  disabled/>
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span class="disable-span">Endorsement IA Levy</span>
              <el-form-item>
                <v-input
                  v-model.number= "showData.endorsement_ia_mib_ec"
                  prepend="HKD"
                  disabled/>
              </el-form-item>
            </div>
          </v-row-col>
        </v-row-col>
        <v-row-col
          :same="true"
          :same-number="24">
          <div class="hr-inline"></div>
        </v-row-col>
      </el-row>
      <el-row
        class="row-bg flex-inline"
        :gutter="20"
        justify="space-around">
        <v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span>Special Discount %</span>
              <el-form-item prop="base_premium">
                <v-input
                  v-model.number="formData.special_discount"
                  append="%"
                  @change="handlerComputed"/>
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span>Special Discount Amount</span>
              <el-form-item>
                <v-input
                  v-model="showData.special_discount_vl"
                  prepend="HKD"
                  disabled
                />
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span class="disable-span">Premium Difference</span>
              <el-form-item>
                <v-input
                  v-model.number="showData.premium_difference"
                  prepend="HKD"
                  disabled/>
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span class="disable-span">IA Levy</span>
              <el-form-item>
                <v-input
                  v-model.number="showData.ia_levy_vl"
                  disabled
                  prepend="HKD"/>
              </el-form-item>
            </div>
          </v-row-col>
        </v-row-col>
        <v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span>Handling Charge</span>
              <el-form-item>
                <v-input
                  v-model.number= "formData.handing_charge"
                  prepend="HKD"
                  @change="handlerComputed"
                />
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span class="disable-span">Endorsement Total Payable</span>
              <el-form-item>
                <v-input
                  v-model.number= "showData.endorsement_total_payable"
                  prepend="HKD"
                  disabled/>
              </el-form-item>
            </div>
          </v-row-col>
        </v-row-col>
        <v-row-col
          :same="true"
          :same-number="24">
          <div class="hr-inline"></div>
        </v-row-col>
      </el-row>
      <el-row
        class="row-bg flex-inline"
        :gutter="30"
        justify="space-around">
        <v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span>Net %</span>
              <el-form-item prop="base_premium">
                <v-input
                  v-model.number="formData.net"
                  append="%"
                  @change="handlerComputed"/>
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span class="disable-span">Net</span>
              <el-form-item >
                <v-input
                  v-model.number="showData.net_vl"
                  prepend="HKD"
                  disabled
                />
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span class="disable-span">Net Comm.$</span>
              <el-form-item>
                <v-input
                  v-model.number= "showData.net_commission_vl"
                  prepend="HKD"
                  disabled/>
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span class="disable-span">Insurer Net %</span>
              <el-form-item>
                <v-input
                  v-model="showData.insurer_net"
                  append="%"
                  disabled
                />
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span class="disable-span">Insurer Net</span>
              <el-form-item>
                <v-input
                  v-model.number="showData.insurer_net_vl"
                  disabled
                  prepend="HKD"/>
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span class="disable-span">Insurer Net Comm.$</span>
              <el-form-item>
                <v-input
                  v-model.number="showData.insurer_net_commission_vl"
                  prepend="HKD"
                  disabled/>
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span class="disable-span">Referrer Comm.</span>
              <el-form-item >
                <v-input
                  v-model.number="showData.referrer_commission_vl"
                  prepend="HKD"
                  disabled/>
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span class="disable-span">RM Comm.</span>
              <el-form-item>
                <v-input
                  v-model.number="showData.owner_commission_vl"
                  prepend="HKD"
                  disabled/>
              </el-form-item>
            </div>
          </v-row-col>
        </v-row-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import {computedEndorsement} from '@api/endorsement'
import {mapState,mapActions} from 'vuex'

export default {
  name: 'endorsement',
  mixins: [MixinOptions,MixinRules],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    formDataLock: {
      type: Number,
      default: 0
    },
    clientType:{
      type: Number,
      default: 1
    }
  },

  data(){
    return{
      is_self:true,
      showData:{
        original_ia_mib_ec:'',
        original_premium:'',
        original_gross_premium:'',
        gross_premium_difference:'',
        ncd:'',
        mib_vl:'',
        ia_levy_vl: '',
        amount_received: '',
        gross_premium:'',
        total_premium:'',
        net_vl:'',
        owner_commission_vl:'',
        insurer_net_commission_vl:'',
        insurer_net_vl:'',
        net_commission_vl:'',
        referrer_commission_vl:'',
        insurer_net: '',
        basic_premium:'',
        endorsement_total_payable:'',
        premium_difference:'',
        basic_premium_difference:'',
        endorsement_ia_mib_ec:'',
        special_discount_vl:'',
        section_2_ia_levy_vl:'',
        premium_third_party:'',
        section_1_ia_levy_vl:'',
        premium_material_damage:''
      },
      formData:{
        ncd:'',
        handing_charge:'',
        base_premium:'',
        loading:'',
        client_discount:'',
        additional_premium:'',
        ia_levy:'',
        special_discount:'',
        net:'',
        endorsement_effective_date:'',
        endorsement_type:[],
        notes:'',
        is_edit:0,
        section_2_ia_levy_vl:'',
        premium_third_party:'',
        section_1_ia_levy_vl:'',
        premium_material_damage:'',
        is_section_1_ia_levy_vl:0,
        is_section_2_ia_levy_vl:0,
      },

    }
  },
  computed:{
    ...mapState('quotation', ['quoteInformationForm','ncd','ncdList']),
    ...mapState('coverage', ['coverageData','riskPremium']),

    order_no(){
      let {order_no=''} = this.quoteInformationForm
      return order_no
    },
    productId(){
      return this.form.product_id
    },
    productMotor(){
      return this.productId == 10
    },
    showEcPercent(){
      return this.productId==13
    },
    showEcHKD(){
      return [13,14,15,16,17,18].includes(this.productId)
    },
    refundName(){
      if(this.productId==10)
        return  ' MIB  '
      else  return  'and EC Levy'
    },
    endorsementType()
    {
      let typesArr = this.globalOptions.endorsement_type
      let arr = []
      typesArr.filter(item=>{
        if(item.product_id == this.productId)
          arr = item.items
      })
      return arr.length<=0?[]:arr
    },
    risk(){
      return this.riskPremium||{}
    },
    is_effective(){
      let {order_status} = this.quoteInformationForm||{}
      return order_status>10&&!this.$route.query.isEndorsement
    },

  },
  watch:{
    ncd:{
      immediate:true,
      handler(val,old){
        this.formData.ncd = val
        if(old>=0&&!this.is_self)
        {
          this.is_self = false
          this.handlerComputed()
        }
      }
    },
    riskPremium: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val) {
          let {section_1, section_2} = val
          if(section_1==0){
            this.formData.premium_material_damage =0
            this.formData.section_1_ia_levy_vl =0
            this.formData.is_section_1_ia_levy_vl =0
          }
          if(section_2==0){
            this.formData.premium_third_party =0
            this.formData.section_2_ia_levy_vl =0
            this.formData.is_section_2_ia_levy_vl =0
          }
          this.handlerComputed()
        }
      }
    }
  },
  created() {
    this.handlerInit()
  },
  methods:{
    ...mapActions('quotation', ['setNcd']),
    ...mapActions('coverage', ['setRiskPremium']),

    handlerCheck(){
      // this.formData.section_1_ia_levy_vl = this.is_section_1_ia_levy_vl? this.formData.section_1_ia_levy_vl:0
      // this.formData.section_2_ia_levy_vl = this.is_section_2_ia_levy_vl? this.formData.section_2_ia_levy_vl:0
      this.handlerComputed()
    },
    handlerInit(){
      if(this.quoteInformationForm){
        let {premium,notes,endorsement_type=[],endorsement_effective_date='',is_edit=0, } = this.quoteInformationForm
        this.showData = Object.assign(this.showData,premium)
        this.formData.endorsement_type = endorsement_type
        this.formData.notes = notes
        this.formData.is_edit =is_edit
        if(is_edit)
          this.formData.endorsement_effective_date = endorsement_effective_date
        Object.keys(this.formData).some(key => {
          if (key in premium) {
            this.formData[key] = premium[key]
          }
        })
        this.is_self = true
        this.network().computedQuotation()
      }
    },
    async submitForm(formName) {
      await new Promise((resolve, reject) => {
        this.$refs['form'].validate(valid => {
          if(valid) {
            this.$emit('getFormData', formName, this.formData)
            resolve(valid)
          } else {
            reject(valid)
          }
        })
      })
    },
    handlerChangeNcd(){
      this.is_self= false
      this.setNcd(this.formData.ncd)
    },
    handlerRisk(){
      let params = {}
      params.premium_material_damage = this.formData.premium_material_damage
      params.premium_third_party = this.formData.premium_third_party
      params.section_1 = this.risk.section_1
      params.section_2 =  this.risk.section_2
      this.setRiskPremium(params)
      // this.handlerComputed()
    },
    handlerComputed(){
      // this.$refs.form.validate((valid, invalidFields) => {
      //   if (valid) {
      this.network().computedQuotation()
      // }else{
      // }
      // })
    },
    network() {
      return {
        computedQuotation:async ()=>{
          this.is_self= false
          let params ={...this.formData,...{order_no:this.order_no,product_id:this.form.product_id}}
          let { data } = await computedEndorsement(params)
          this.showData = data
          let {endorsement_effective_date,handing_charge} = data
          this.formData.endorsement_effective_date = endorsement_effective_date
          this.formData.handing_charge = handing_charge
          Object.keys(this.formData).some(key => {
            if (key in data) {
              this.formData[key] = data[key]
            }
          })
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.flex-inline{
  .form-item{
    display: flex;
    margin-bottom: 16px;
    align-items: center;
    span{
      flex: 1;
    }
    .disable-span{
      color: #718096;
    }
    .el-form-item{
      flex: 2;
    }

  }
  .hr-inline{
    margin:20px 10px;
  }
}
</style>
